module.exports = __webpack_public_path__ + "static/media/Bg.9d9e4b9e.png";